import React from "react"
import {graphql, useStaticQuery, Link} from "gatsby"
import { navigate } from "gatsby-link"

import pageTitleStyles from './page_titles.module.scss'
import tabbedStyles from './games_tabbed.module.scss'

import Games from './games_box'
import BetView from "./bet_view"
import ConfView from "./confidence_view"
import ModelPerf from "./model_perf"


const GamesTabbed = ({activeIndex}) => {

    const tabs = [
        {
            'index' : 0,
            'id' : 'games',
            'name' : 'Games',
            'component' : <Games />,
            'route' : '/games',
        }, 
        {
            'index' : 1,
            'id' : 'betting_card',
            'name' : 'Betting Card',
            'component' : <BetView />,
            'route' : '/games/nfl-ev-bets',
        }, 
        {
            'index' : 2,
            'id' : 'confidence_pool',
            'name' : 'Confidence Pool',
            'component' : <ConfView />,
            'route' : '/games/nfl-confidence-picks',
        }, 
        {
            'index' : 3,
            'id' : 'model_perf',
            'name' : 'Model Performance',
            'component' : <ModelPerf />,
            'route' : '/games/nfl-model-performance',
        }, 
    ]

    const tabToDisplay =  tabs[activeIndex]['component']

    const data = useStaticQuery(graphql`
        query {
            allProjectedSpreadsCsv {
            nodes {
                season
                week
                last_week
                last_season
            }
            }
        }
    `)

    var last_week = data.allProjectedSpreadsCsv.nodes[0].last_week
    var last_season = data.allProjectedSpreadsCsv.nodes[0].last_season

    return (
        <div className={pageTitleStyles.page_container}>
            <div className={pageTitleStyles.title_div}>
                <h2 className={pageTitleStyles.title_h2}>Games</h2>
                <h3 className={pageTitleStyles.title_h3}>
                    Week {data.allProjectedSpreadsCsv.nodes[0].week}, {data.allProjectedSpreadsCsv.nodes[0].season}
                </h3>
            </div>
            <div className={tabbedStyles.tab_container}>
                {tabs.map((item) => {
                    return (
                        <button
                            className={tabbedStyles.tab_button}
                            key={item.id}
                            onClick={()=> {navigate(item.route)}}
                            data-active={activeIndex===item.index ? true : false }
                        >
                            {item.name}
                        </button>
                    )
                })}
                <Link className={pageTitleStyles.navLink} to={`/weeks/${last_season}/${last_week}/`}>  Last week recap</Link>
            </div>
            {tabToDisplay}
        </div>
    )
}

export default GamesTabbed